const request = require('request');
const config = require('./config');

var get = (token,id) => {

  return new Promise((resolve,reject) => {
    request({
      headers: {
        'Content-Type': 'application/json',
        'User-Token': token
      },
      uri: `${config.URL_BACKEND}/scorecard/${id}`,
      method: 'GET'
    }, (err, res, body) => {
      resolve({err: err, res: res, body: body})
    });
  });
  
};

module.exports = {
  get: get
};